import React from 'react';

const Root = () => {
  return <div id="RootPage">IR Admin Dashboard</div>;
};

export default Root;
